import { UseCasePage } from '@/components/marketing/use-case-page'

export function UseCasesFoundersPage() {
  return (
    <UseCasePage
      contentKey="useCasesFounders"
      path="/use-cases/founders"
      relatedKeys={['useCasesKnowledgeWorkers', 'whatIsKnowledgeGraph', 'comparePerplexity']}
    />
  )
}
